// @flow
import * as React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import Radio from 'common/domain/radio';
import PrintingHeader from 'common/modules/printing/components/PrintingHeader';
import GeolocalisationPrintingCard from 'statsradio/modules/dashboard/printing/GeolocalisationPrintingCard';
import type { GeoMapTypes } from 'statsradio/modules/dashboard/domain/DashboardData';
import DemoGeoPrintingCard from 'statsradio/modules/dashboard/printing/DemoGeoPrintingCard';

import SalesFlyerPrintingSummary from './SalesFlyerPrintingSummary';
import { Colors, Metrics } from '../../../../themes';
import type { SalesFlyer } from '../../domain/sales';
import { CentralMarket } from '../../../centralMarkets/domain/CentralMarket';

type Props = {
  flyer: SalesFlyer,
  radio: Radio,
  t: any,
  geoMapType: GeoMapTypes,
  geoMapData: Object,
  centralMarket: ?CentralMarket;
}

const Wrapper = styled.div`
  width: 100%;
  padding: 3px;
  background-color: white;
  box-sizing: border-box;

  width: 21.59cm;
  font-size: 12px;

  @page {
    size: letter portrait;
    margin: 2.00cm 0 2.00cm 0;
  }
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${Metrics.margin}px 0;
`;

const Text = styled.div`
  color: ${Colors.secondaryText};
  font-size: 14px;
  margin-top: ${Metrics.tinyMargin}px;
`;

const Content = styled.div`
  margin-top: 0px;
`;

function SalesFlyerPrinting({ flyer, radio, t, geoMapType, geoMapData, centralMarket }: Props) {
  return (
    <Wrapper>
      <PrintingHeader radio={radio} centralMarket={centralMarket} />
      <Header>
        <Text>{t('flyerInformationMessage', { from: flyer.from, to: flyer.to })}</Text>
      </Header>
      <Content>
        <SalesFlyerPrintingSummary flyer={flyer} />
        <div className="flexbox-children-spaced">
          <GeolocalisationPrintingCard
            geolocalisation={flyer.reachByRegion}
            antennaReach={flyer.antennaReach}
            geoMapType={geoMapType}
            geoMapData={geoMapData}
          />
          <DemoGeoPrintingCard gender={flyer.genders} ageRange={flyer.ages} />
        </div>
      </Content>
    </Wrapper>
  );
}

export default translate('sales')(SalesFlyerPrinting);



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/components/printing/SalesFlyerPrinting.js